if (!Array.isEqual) {
  Array.isEqual = function(arr1, arr2, func) {
    let isEqual = true;

    if (!arr1 || !arr2 || !func) {
      isEqual = false;
    }
    else {
      isEqual = func(arr1, arr2);
    }

    return isEqual;
  };
}

if (!Array.isEmpty) {
  Array.isEmpty = function(arr) {
    return !arr || (Array.isArray(arr) && (!arr || !arr.length));
  };
}
